export default "__VITE_ASSET__b3bf584f__"